// Deterministic PRNG (mulberry32) so daily-challenge puzzles are
// reproducible from a numeric seed instead of Math.random().
export function mulberry32(seed) {
  let state = seed >>> 0;
  return function () {
    state = (state + 0x6D2B79F5) | 0;
    let t = Math.imul(state ^ (state >>> 15), 1 | state);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

// Turns an arbitrary string (e.g. a date) into a numeric seed for mulberry32.
export function hashStringToSeed(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) | 0;
  }
  return hash >>> 0;
}

// Calendar date (UTC) as "YYYY-MM-DD", used as the daily-challenge seed input
// so every player gets the same puzzle for the same day regardless of timezone.
export function getUTCDateString(date = new Date()) {
  return date.toISOString().slice(0, 10);
}

export function isMoveCorrect(solution, row, col, value) {
  return solution[row][col] === value;
}

export function emptyNotes() {
  return Array(9).fill().map(() => Array(9).fill().map(() => []));
}

// Returns a new notes grid with `num` added to/removed from cell (row, col).
export function toggleNote(notes, row, col, num) {
  const next = notes.map(r => r.map(cell => [...cell]));
  const cell = next[row][col];
  const idx = cell.indexOf(num);
  if (idx === -1) {
    cell.push(num);
    cell.sort((a, b) => a - b);
  } else {
    cell.splice(idx, 1);
  }
  return next;
}

/** Format elapsed seconds as m:ss (e.g. 0:00, 1:05, 12:03). */
export function formatTimer(seconds) {
  const total = Math.max(0, Math.floor(Number(seconds) || 0));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

/** Count how many times digit n appears in the grid. */
export function countDigit(userGrid, n) {
  let count = 0;
  for (let r = 0; r < userGrid.length; r++) {
    for (let c = 0; c < userGrid[r].length; c++) {
      if (userGrid[r][c] === n) count += 1;
    }
  }
  return count;
}
